import api from './api';
import ErrorService from './errorService';



export const claveClienteService = {

  getClaveCliente: async () => {
        try {
          const response = await ErrorService.withTimeout(api.get(`/ClaveUnica`));
          return response.data;      
        } catch (error) {
          ErrorService.handleApiError('Error al obtener:', error);
          throw error;
        }
      },



};